import React from 'react'
// Layout na dole używamy tylko, by zyskać spójny footer; nagłówek zapewnia MarketingHeader zgodny z home
// Usuwamy Layout jako wrapper na dole – wstawimy lokalny footer bez dodatkowego paska
// import Layout from '../components/layout/Layout'
import MarketingHeader from '../components/marketing/MarketingHeader'
import Seo from '../components/Seo'
import { showPreferences } from '../utils/cookieConsentConfig'

interface BlogMeta {
  title: string
  description: string
  date: string
  updated?: string
  slug: string
  ogImage?: string
}

const BlogIndex: React.FC = () => {
  const [posts, setPosts] = React.useState<BlogMeta[] | null>(null)

  React.useEffect(() => {
    const modules = import.meta.glob('../../content/blog/*.mdx')
    Promise.all(
      Object.values(modules).map(async (loader: any) => {
        const m = await loader()
        return m.frontmatter as BlogMeta
      })
    ).then(list => {
      setPosts(list.sort((a, b) => (a.date < b.date ? 1 : -1)))
    }).catch(() => setPosts([]))
  }, [])

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <MarketingHeader />
      <Seo title="Blog — opieka naprzemienna" canonical="https://2domy.pl/blog" robots="index,follow" />
      <main className="flex-grow max-w-6xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6">Blog: opieka naprzemienna</h1>
        {posts && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'ItemList',
                itemListElement: posts.map((p, idx) => ({
                  '@type': 'ListItem',
                  position: idx + 1,
                  url: `https://2domy.pl/blog/${p.slug}`,
                  name: p.title
                }))
              })
            }}
          />
        )}
        {!posts ? (
          <div>Ładowanie…</div>
        ) : (
          <div className="grid gap-4 md:gap-6">
            {(() => {
              // 1) już posortowane po dacie malejąco (w useEffect)
              const arr = [...posts]
              // 2) przenieś wpis wzorcowy na początek
              const pinnedIdx = arr.findIndex(p => p.slug === 'opieka-naprzemienna-praktyka')
              if (pinnedIdx > 0) {
                const [pinned] = arr.splice(pinnedIdx, 1)
                arr.unshift(pinned)
              }
              // 3) wstaw "porozumienie-rodzicielskie" na 3. miejsce listy (indeks 2), jeśli istnieje
              const prIdx = arr.findIndex(p => p.slug === 'porozumienie-rodzicielskie')
              if (prIdx !== -1) {
                const [pr] = arr.splice(prIdx, 1)
                const targetIndex = Math.min(2, arr.length)
                arr.splice(targetIndex, 0, pr)
              }
              return arr
            })().map(p => (
              <a key={p.slug} href={`/blog/${p.slug}`} className="group grid grid-cols-[88px_1fr] sm:grid-cols-[120px_1fr] gap-4 p-4 rounded-lg border bg-white hover:shadow transition">
                <div className="relative w-[88px] h-[66px] sm:w-[120px] sm:h-[90px] rounded-md overflow-hidden border bg-slate-100">
                  <img
                    src={p.ogImage || '/blog/placeholder.webp'}
                    alt={p.title}
                    className="absolute inset-0 w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h2 className="text-lg sm:text-xl font-semibold group-hover:underline">{p.title}</h2>
                  <p className="text-slate-600 mt-1 text-sm">{p.description}</p>
                  <div className="text-xs text-slate-500 mt-2">{new Date(p.updated || p.date).toLocaleDateString('pl-PL')}</div>
                </div>
              </a>
            ))}
          </div>
        )}
      </main>
      <footer className="bg-gradient-to-r from-slate-800 to-slate-900 text-white py-8 mt-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-slate-300">&copy; {new Date().getFullYear()} 2domy.pl - Kalendarz opieki naprzemiennej dla rodziców i opiekunów</p>
          <div className="mt-3 flex items-center justify-center gap-2 text-slate-400 text-xs flex-wrap">
            <a href="/terms" className="hover:underline">Regulamin</a>
            <span>•</span>
            <a href="/polityka-prywatnosci" className="hover:underline">Polityka prywatności</a>
            <span>•</span>
            <button
              className="hover:underline bg-transparent border-0 p-0 text-inherit cursor-pointer"
              onClick={(e) => {
                e.preventDefault()
                showPreferences()
              }}
            >
              Zarządzaj zgodą
            </button>
            <span>•</span>
            <a href="/contact" className="hover:underline">Kontakt</a>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default BlogIndex


